import * as React from 'react';
import { Button, Form, Radio, Segment, Modal, Label } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth from '../../../api';
import Toast from '../../../sys/toast';

class State {
    config: string;
    showModal: boolean;
}

interface Props {

}

export default class SaveconfigPanel extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            config: 'save',
            showModal: false
        });
    }

    updateConfig(e: any, data: any) {

        let url = ''; let dataObject = {};
        let message = 'Restarting...please wait.';
        let toastmsg: string;

        if (this.state.config === 'save') {
            url = 'http://default/api/config/save';
            message = 'Saving Configuration';
            toastmsg = 'Configuration saved';
        } else {
            url = 'http://default/api/sys/restart';
        }
        if (this.state.config === 'saveRestart') {
            dataObject = {
                'save': true
            };
            message = 'Saving Configuration';
            toastmsg = 'Configuration saved';
        } else if (this.state.config === 'restart') {
            dataObject = {
                'save': false
            };
            message = 'Restarting Service ...';
            toastmsg = 'Restarting Service ...';
        } else if (this.state.config === 'reset') {
            dataObject = {
                'factoryReset': true
            };
            message = 'Performing Factory Reset';
            toastmsg = 'Configuration reset to factory settings';
        }

        axios.post(url, dataObject, {
            headers: {
                'x-meta-caption': message // triggers loader during the request
            }
        })
            .then( (response: AxiosResponse) => {
                if (response.data !== undefined && response.data.code === 'SUCCESS' ) {
                    if (toastmsg) Toast.info(toastmsg);

                    if (this.state.config !== 'save') {
                        // must show popup and wait for the server to respond again
                        const { oauth, key } = OAuth.getContextFromResponseObject(response);
                        if (oauth) {
                            oauth.waitforServer({message: 'Waiting for restart to complete...'}, key)
                            // .then()   // could use then() to capture a success condition but should not happen since we expect a reboot
                            // tslint:disable-next-line:no-console
                                .catch(er => console.log(er));  // this is always called if the server reboot succeeds (but we get redirected to login anyway)
                        }
                    }
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('save config error: ', error);
                Toast.error('error saving configuration');
            });
    }

    handleModalClose() {
        this.setState({
            showModal: false
        });
    }
    render() {
        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <React.Fragment>
                <div className="assetAliasFilters">
                    <Label className="system-config-pageHeader">
                        Save Config
                    </Label>
                    <Button
                        floated="right"
                        className="rightButton"
                        content="Apply"
                        title="Update Config"
                        onClick={(e, data) => this.updateConfig(e, data)}
                    />
                </div>
                <Segment.Group className="system-config-segment">
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Radio
                                    label="Save Configuration"
                                    name="radioGroup"
                                    className="radio-label"
                                    value="save"
                                    checked={this.state.config === 'save'}
                                    onChange={(e: any, data: any) => this.setState({config: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Radio
                                    label="Save Configuration and Restart Service"
                                    name="radioGroup"
                                    value="saveRestart"
                                    className="radio-label"
                                    checked={this.state.config === 'saveRestart'}
                                    onChange={(e: any, data: any) => this.setState({config: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Radio
                                    label="Restart Service"
                                    name="radioGroup"
                                    value="restart"
                                    className="radio-label"
                                    checked={this.state.config === 'restart'}
                                    onChange={(e: any, data: any) => this.setState({config: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Radio
                                    label="Reset to Factory Defaults"
                                    name="radioGroup"
                                    value="reset"
                                    className="radio-label"
                                    checked={this.state.config === 'reset'}
                                    onChange={(e: any, data: any) => this.setState({config: data.value})}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                </Segment.Group>
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Save</Modal.Header>
                    <Modal.Content>
                        Success!
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn" onClick={() => this.handleModalClose()}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/saveconfigPanel.tsx